module.exports = __webpack_public_path__ + "CO.png?84ceb1d6708e787a162aa80505587236";